import React, { useMemo } from "react";
import numeral from "numeral";
import moment from "moment";
import styled from "styled-components";
import { LinkContainer, Spinner } from "components/common";
import { Alert, Col, Row, Button } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import Routes from "routing/Routes";
import { DocumentationLink } from "components/support";
import useIndexerFailuresCount from "components/indexers/hooks/useIndexerFailuresCount";
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;
const formatTextForFailureCount = (count) => {
  if (count === 0) {
    return "No failed indexing attempts in the last 24 hours.";
  }
  return /* @__PURE__ */ React.createElement("strong", null, "There were ", numeral(count).format("0,0"), " failed indexing attempts in the last 24 hours.");
};
const IndexerFailuresComponent = () => {
  const since = useMemo(() => moment().subtract(24, "hours").format("YYYY-MM-DDTHH:mm:ss.SSS"), []);
  const { data: total, isLoading } = useIndexerFailuresCount(since);
  const failuresSummary = total !== void 0 ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: total === 0 ? "success" : "danger" }, formatTextForFailureCount(total), /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.INDICES.FAILURES }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", className: "pull-right" }, "Show errors"))) : null;
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("h2", null, "Indexer failures"), /* @__PURE__ */ React.createElement(
    DocumentationLink,
    {
      page: DocsHelper.PAGES.INDEXER_FAILURES,
      text: "Indexer failures documentation",
      displayIcon: true
    }
  )), /* @__PURE__ */ React.createElement("p", { className: "description" }, "Every message that was not successfully indexed will be logged as an indexer failure."), isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : failuresSummary));
};
export default IndexerFailuresComponent;
